<div mat-dialog-header class="title">
    Target Interval Settings (Device)
</div>
<target-interval-settings *ngIf="(device$ | async)" [model]="device$ | async" [saveFn]="saveDevice" [visibleDeviceDropDown]="visibleDeviceDropDown"></target-interval-settings>
<div *ngIf="(device$|async) == undefined" class="container centered-content">
    <mat-spinner strokeWidth="3" [diameter]="50"></mat-spinner>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="cancel()">Cancel</button>
    <button mat-flat-button color="warn" (click)="saveSetting()">Save Interval Setting</button>
</div>